export default "__VITE_ASSET__CRGyCvif__"